var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClientSetup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5667 7.15005V12.85C17.5667 13.7834 17.0667 14.6501 16.2584 15.1251L11.3084 17.9834C10.5 18.45 9.50005 18.45 8.68338 17.9834L3.73338 15.1251C2.92505 14.6584 2.42505 13.7917 2.42505 12.85V7.15005C2.42505 6.21672 2.92505 5.35001 3.73338 4.87501L8.68338 2.01669C9.49172 1.55002 10.4917 1.55002 11.3084 2.01669L16.2584 4.87501C17.0667 5.35001 17.5667 6.20838 17.5667 7.15005Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 10.8333C11.0722 10.8333 11.9416 9.964 11.9416 8.89164C11.9416 7.81929 11.0722 6.95001 9.99989 6.95001C8.92754 6.95001 8.05823 7.81929 8.05823 8.89164C8.05823 9.964 8.92754 10.8333 9.99989 10.8333Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.8833C13.3333 12.3833 11.8416 11.1667 9.99996 11.1667C8.15829 11.1667 6.66663 12.3833 6.66663 13.8833",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClientSetup);
export default __webpack_public_path__ + "static/media/ic_client_setup.9da1af11884e085a693ea7d5d03c981d.svg";
export { ForwardRef as ReactComponent };